import { useState } from "react";

const VideoWithLoader = (props) => {
  const [loading, setLoading] = useState(true);

  return (
    <span
      style={{
        display: "flex",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <div
            style={{
              width: 100,
              height: 100,
            }}
          >
            <div className="loader"></div>
          </div>
        </div>
      )}
      <video
        {...props}
        style={{
          width: "auto",
          maxWidth: "100%",
          height: "auto",
          margin: "20px 0",
          border: "2px solid #ccc",
          borderRadius: "8px",
          padding: "5px",
          display: loading ? "none" : "block",
        }}
        autoPlay
        loop
        muted
        onLoadStart={() => setLoading(true)}
        onLoadedData={() => setLoading(false)}
      />
    </span>
  );
};

export default VideoWithLoader;
